import { Box } from "@mui/material";

const ContactMap = () => {
  return (
    <Box sx={{ width: "100%", height: "100%" }}>
      <iframe
        title="map"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3546.056894897042!2d81.00334339999999!3d26.8411291!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x399be30c5ffcfa33%3A0xcfa1e79bc7b34848!2sShankh%20Tower!5e1!3m2!1sen!2sin!4v1770377929669!5m2!1sen!2sin"
        width="100%"
        height="100%"
        style={{ border: 0, minHeight: 500 }}
        loading="lazy"
      />
    </Box>
  );
};

export default ContactMap;